module.exports = __webpack_public_path__ + "media/images/icon__plus@2x-4c7b6606532fd92270a4c4d7e5373b7b.png";